<!-- View Selection -->
<div
    [ngClass]="[
        'views-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
    *ngIf="mimics"
>
    <app-scroll-navigator
        class="scroll-navigator-container"
        [items]="mimics"
        [selectedId]="selectedMimic?.id"
        [routerPath]="['/ops', 'mimics', '']"
    />
</div>

<div
    [ngClass]="[
        'mimic-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
    #mimicContainer
>
    <lib-mimic-viewer
        *ngIf="selectedMimic; else loadingSpinner"
        [mimic]="selectedMimic"
        [width]="maxWidth"
        [height]="maxHeight"
        [elementsSettings]="elementsSettings"
        [channelsUpdateObservable]="getUpdatedTagValue"
        [defaultColors]="defaultColors"
        [vesselId]="vesselId"
    >
    </lib-mimic-viewer>
</div>

<ng-template #loadingSpinner>
    <app-loading-spinner></app-loading-spinner>
</ng-template>
